import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowsExpandDiagonal4 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 20L12 12L4.00006 4", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 11L4 4L11 4", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20 13L20 20L13 20", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowsExpandDiagonal4.js.map